"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _Directions = _interopRequireDefault(require("@material-ui/icons/Directions"));

var _ui = require("@probeton/ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RepresentativeUnits = function RepresentativeUnits(_ref) {
  var units = _ref.units,
      handleUnitClick = _ref.handleUnitClick;
  return /*#__PURE__*/_react["default"].createElement(_core.List, null, units.map(function (_ref2) {
    var key = _ref2.key,
        location = _ref2.location,
        name = _ref2.name,
        _id = _ref2._id;
    return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_Directions["default"], null),
      textLabel: location.formatted_address,
      text: "".concat(key, ". ").concat(name),
      onClick: function onClick() {
        return handleUnitClick(_id);
      }
    });
  }));
};

var _default = RepresentativeUnits;
exports["default"] = _default;